import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/Main.vue'
import {blankDashboardRoutes, dashboardRoutes} from "./_helpers/routes";
import {indexRoute} from "./_helpers/routes";

Vue.use(Router)

function lazyLoad(view){
  return() => import(`@/views/${view}.vue`)
}
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
      children: [
        {
          path: '',
          name: 'home',
          component: indexRoute()
        },
        {
          path : 'colleges',
          name: 'colleges',
          component: lazyLoad('Home')
        },
        {
          path: 'internships',
          name: 'internships',
          component: lazyLoad('Internships')
        },
        {
          path: 'jobs',
          name: 'jobs',
          component: lazyLoad('Jobs')
        },
        {
          path: 'companies',
          name: 'companies',
          component: lazyLoad('Companies')
        },
        {
          path: 'detail',
          name: 'jobDetail',
          component: lazyLoad('JobDetail')
        },
        {
          path: 'webinar-detail',
          name: 'webinarDetail',
          component: lazyLoad('WebinarDetail')
        },
        {
          path: 'godaddy-academy',
          name: 'godaddyAcademy',
          component: lazyLoad('GodaddyAcademy')
        },
        {
            path: 'profile',
            name: 'organizationProfile',
            component: lazyLoad('OrganizationProfile')
        },
        {
          path: 'education-loan/apply',
          name: 'applyLoan',
          component: lazyLoad('ApplyLoan')
        },
        {
          path: 'admission-form',
          name: 'admissionForm',
          component: lazyLoad('AdmissionForm')
        },
        {
          path: 'quiz-list',
          name: 'quiz_list',
          component: lazyLoad('QuizList')
        },
        {
          path: 'quizzes',
          name: 'quizzes',
          component: lazyLoad('QuizList')
        },
        {
          path: '/quiz/detail/:id',
          name: 'quiz_detail',
          component: lazyLoad('QuizDetail')
        },
        {
          path: '/quiz/:id',
          name: 'quizzes_detail',
          component: lazyLoad('QuizDetail')
        },
      ]
    },
    {
      path: '/signup',
      name: 'signup',
      component: lazyLoad('Signup')
    },
    dashboardRoutes(),
    blankDashboardRoutes(),
    {
      path: '*',
      redirect: '/'
    }
  ]
})
